import { render, staticRenderFns } from "./ResourceLibrary.vue?vue&type=template&id=1dafafc7"
import script from "./ResourceLibrary.ts?vue&type=script&lang=ts&external"
export * from "./ResourceLibrary.ts?vue&type=script&lang=ts&external"
import style0 from "./ResourceLibrary.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports